import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface HotColdState {
  isColdSelected: boolean;
  setIsColdSelected: (isColdSelected: boolean) => void;
}

const DEFAULT_IS_COLD_SELECTED = false;

export const useHotColdStore = create<HotColdState>()(
  devtools<HotColdState>((set) => ({
    isColdSelected: DEFAULT_IS_COLD_SELECTED,
    setIsColdSelected: (isColdSelected: boolean) => set({ isColdSelected }),
  }))
);
